import React from 'react'
import WindowContent from '../../UI/WindowContent'
import WindowTitle from '../../UI/WndowTitle'

import styled from 'styled-components'
import Select from 'react-select'

const Row = styled.div`
  display: flex;
  margin-block: 10px;
`
const Title = styled.div`
  width: 200px;
  font-weight: 600;
`

const Description = styled.div`
  width: 100%;
`

const StyledSelect = styled(Select)`
  width: 200px;
`
type Props = {
  title: string
  fields: any[]
  data: any
}

const IncidentWindow: React.FC<Props> = (props) => {
  const { title, fields, data } = props

  // const [value, setValue] = useState(options[0])
  // const onchangeSelect = (item) => {
  //   setValue(item)
  // }

  return (
    <>
      <WindowTitle>{title}</WindowTitle>

      <WindowContent>
        {fields.map((field, key) => {
          return (
            <Row key={key}>
              <Title>{field.label}</Title>

              <Description>
                {field.type === 'dropdown' ? (
                  <StyledSelect
                    name={field.accessor}
                    defaultValue={data[field.accessor][0]}
                    options={data[field.accessor]}
                  />
                ) : (
                  field.accessor
                    .split('.')
                    .reduce(
                      (windowFields, accessor) =>
                        (windowFields && windowFields[accessor]) || null,
                      data
                    )
                )}
              </Description>
            </Row>
          )
        })}
      </WindowContent>
    </>
  )
}

export default IncidentWindow
